import { Link } from 'react-router-dom';

/**
 * Where PayFast returns the buyer if they cancel.
 *
 * Nothing was created and nothing was charged — the pending registration is
 * simply left unused. Deliberately reassuring about that: someone who backed
 * out of a payment page wants to know they haven't been billed.
 */
export default function RegisterCancelled() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment cancelled</h1>
        <p className="text-sm text-gray-600 mb-6">
          You haven't been charged and no site was created. You can pick up where you left off
          whenever you're ready.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/register"
            className="px-6 py-2.5 rounded-lg bg-brand-600 text-white text-sm font-semibold hover:bg-brand-700 transition-colors"
          >
            Try again
          </Link>
          <Link to="/" className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">
            Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
